'use strict';

const FavoriteModel = require('bunsen/models/identity/Favorite');
const FavoritesCollection = require('bunsen/collections/identity/Favorites');
const SaveSearchModel = require('../models/SaveSearchModel');

const BaseStore = require('fluxible/addons/BaseStore');

class FavoritesStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);

        this._isFetched = false;
        this._isLoading = false;
        this._favoriteCanceled = false;
        this._error = null;

        this._collection = new FavoritesCollection([], {
            model: FavoriteModel
        });

        this._itemsState = {
            items: {},
            isFetching: false
        };

        this._saveSearchModel = new SaveSearchModel();
    }

    _onFetchStart() {
        this._error = null;
        this._isLoading = true;
        this.emitChange();
    }

    _onFetchEnd() {
        this._isFetched = true;
        this._isLoading = false;
        this.emitChange();
    }

    _onFetchError(error) {
        this._isFetched = false;
        this._isLoading = false;
        this._error = error;
        this.emitChange();
    }

    _onFavoriteError(error) {
        this._error = error;
        this.emitChange();
    }

    _onFavoriteAdd(model) {
        this._collection.add(model);
        this.emitChange();
    }

    _onFavoriteRemove(model) {
        delete this._itemsState.items[model.id];
        this._collection.remove(model);
        this.emitChange();
    }

    // This might get called A LOT if you're fetching lots of items
    // So we don't call emitChange here, instead we hook to the isFetching fag
    _onFavoriteItemFetchSuccess({id, items}) {
        this._itemsState.items[id] = items;
    }

    _onFavoriteItemFetchProgress({isFetching}) {
        this._itemsState.isFetching = isFetching;
        this.emitChange();
    }

    _onFavoriteCanceled() {
        this._favoriteCanceled = true;
        this.emitChange();

        this._favoriteCanceled = false;
    }

    getFavoritesCollection() {
        return this._collection;
    }

    getFavoriteModelInstance() {
        return this._collection.model;
    }

    getFavoriteModel(id) {
        return this._collection.get(id);
    }

    getFavoritesByType(type) {
        return this._collection.models.filter(model => model.get('type') === type);
    }

    getSaveSearchModel() {
        return this._saveSearchModel;
    }

    getFavoriteItems() {
        return this._itemsState.items;
    }

    isFetchingFavoriteItems() {
        return this._itemsState.isFetching;
    }

    /**
     * @return {Object} - with favorites ids as keys containing an array with display params
     */
    getDisplayParams() {
        return this._collection.models.reduce((obj, current) => {
            const {id} = current;
            obj[id] = this.getDisplayParamsById({id});
            return obj;
        }, {});
    }

    /**
     * Return display parameters(that are flagged as not internal in the model) for a given favorite id.
     * @param  {Number} {id} - Favorite id
     * @return {Array}
     */
    getDisplayParamsById({id}) {
        return this.getFavoriteModel(id)
            .get('parameters')
            .filter(model => !model.isInternal())
            .map(model => ({
                key: model.get('key'),
                displayValue: model.getDisplayValue(),
                displayKey: model.getDisplayKey()
            }));
    }

    isFetched() {
        return this._isFetched;
    }

    isLoading() {
        return this._isLoading;
    }

    isCanceled() {
        return this._favoriteCanceled;
    }

}

FavoritesStore.storeName = 'FavoritesStore';

FavoritesStore.handlers = {
    'favorites:fetch:start': '_onFetchStart',
    'favorites:fetch:end': '_onFetchEnd',
    'favorites:fetch:error': '_onFetchError',

    'favorites:favorite:add': '_onFavoriteAdd',
    'favorites:favorite:remove': '_onFavoriteRemove',
    'favorites:error': '_onFavoriteError',
    'favorites:items:fetch:success': '_onFavoriteItemFetchSuccess',
    'favorites:items:fetch:progress': '_onFavoriteItemFetchProgress',

    'favorite:canceled': '_onFavoriteCanceled'
};

module.exports = FavoritesStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/FavoritesStore.es.js